module.exports = __webpack_public_path__ + "static/actionbar-case-do-fed21249b533d05e753c3e34c30a2f6b.png";